import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useClinic } from "../../context/ClinicContext";
import '../../styles/CustomizeChatbot.css';

export default function CustomizeChatbot() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();
  const { clinicId, setClinicId } = useClinic();

  useEffect(() => {
    if (token) {
      setClinicId(token);
    }
  }, [token, setClinicId]);

  const handleContinue = () => {
  if (clinicId) {
    navigate(`/admin/aitraining?token=${clinicId}`);
  } else {
    alert("❌ Clinic ID is missing. Please go back and try again.");
  }
};

  const handleBack = () => {
    navigate("/admin/create-clinic");
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="header-row">
        <div className="header-left">
          <img src="/logo.png" alt="Olumis AI Logo" className="logo" />
          <button className="all-clinics-btn" onClick={() => navigate("/admin/all-clinics")}>All Clinics</button>
        </div>
      </div>

      {/* Stepper */}
      <div className="stepper">
        <button className="step active">Create New Clinic</button>
        <div className="step-divider" />
        <button className="step current">Customize Chatbot</button>
        <div className="step-divider" />
        <button className="step inactive">AI Training</button>
        <div className="step-divider" />
        <button className="step inactive">Publish</button>
      </div>

      {/* Show clinic ID for debug or reference */}
      {clinicId && (
        <p style={{ marginBottom: '20px', fontStyle: 'italic' }}>
          Customizing chatbot for clinic ID: <strong>{clinicId}</strong>
        </p>
      )}

      <div className="content">
        {/* Settings Form */}
        <form className="settings">
          <div className="row">
            <label>Language: <select /></label>
            <label>Tone: <select /></label>
            <label>Act As: <select /></label>
          </div>

          <div className="section">
            <label>Icon:</label>
            <div className="icon-options">
              <label><input type="radio" name="icon" defaultChecked /> <span className="circle blue" /> Default</label>
              <label><input type="radio" name="icon" /> <span className="circle red" /> Custom</label>
            </div>
          </div>

          <div className="row">
            <label>Font Size: <input type="number" /></label>
            <label>Width: <input type="text" /></label>
            <label>Height: <input type="text" /></label>
            <label>Font Color: <input type="color" /></label>
            <label>Button Color: <input type="color" /></label>
            <label>Border Radius - Window: <input type="text" /></label>
            <label>Text Field Height: <input type="text" /></label>
            <label>Border Radius - Text Field: <input type="text" /></label>
            <label>Text Field Background: <input type="color" /></label>
            <label>User Message Color: <input type="color" /></label>
            <label>AI Message Color: <input type="color" /></label>
          </div>

          <div className="row">
            <label><input type="radio" name="position" /> Left</label>
            <label><input type="radio" name="position" defaultChecked /> Right</label>
          </div>

          <div className="row">
            <label><input type="checkbox" defaultChecked /> Full Screen Button</label>
            <label><input type="checkbox" defaultChecked /> Close Button</label>
            <label><input type="checkbox" defaultChecked /> Download Button</label>
          </div>

          <div className="row">
            <label>AI Name: <input type="text" /></label>
            <label>AI Thinking: <select /></label>
          </div>

          <label>Placeholder: <input type="text" className="long" /></label>
          <label>Welcome Message: <input type="text" className="long" /></label>
          <label>Footer Notes: <input type="text" className="long" /></label>
        </form>

        {/* Live Preview */}
        <div className="preview">
          <div className="preview-header">
            <span>Live Preview</span>
          </div>

          <div className="chatbox">
            <div className="chatbox-controls">
              <button>⛶</button>
              <button>⬇️</button>
              <button>❌</button>
            </div>

            <div className="chat-message">
              <div className="chat-icon"></div>
              <div className="bubble">Hello, this is Lisa. I am a professional aesthetic assistant. Please feel free to ask me anything!</div>
            </div>

            <div className="chat-input">
              <input type="text" placeholder="Type a message here" />
              <button>➤</button>
            </div>

            <p className="footer">Powered by Olumis AI</p>
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="nav-buttons">
        <button onClick={handleBack} className="nav-btn">Back</button>
        <button onClick={handleContinue} className="nav-btn">Continue</button>
      </div>
    </div>
  );
}
